import type { SettingControlModel } from "@medsurf/flat-services";

export type WindowWithConfig = Window & {
  config?: SettingControlModel
}

const config = (window as WindowWithConfig)?.config;
if (config) {
  config.s3endpointUrl = (config?.s3Secure ? 'https' : 'http') + '://' + config?.s3Host + ':' + config?.s3Port + '/';
  config.endpointUrl += config.endpointUrl?.endsWith('/') ? '' : '/';
  config.viewerUrl += config.viewerUrl?.endsWith('/') ? '' : '/';
}

export { config };
